/* eslint-disable react-refresh/only-export-components */

import * as React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '@/lib/utils';

const badgeVariants = cva(
  'inline-flex items-center gap-1 rounded-full font-bold whitespace-nowrap',
  {
    variants: {
      variant: {
        default: 'border border-border-subtle bg-muted text-text-secondary',
        primary: 'border border-border-brand bg-brand-50 text-brand-700',
        success: 'border border-success-border bg-success-surface text-success-text',
        warning: 'border border-warning-border bg-warning-surface text-warning-text',
        error: 'border border-error-border bg-error-surface text-error-text',
        info: 'border border-info-border bg-info-surface text-info-text',
        outline: 'border border-border-strong text-text-secondary',
      },
      size: {
        default: 'px-2.5 py-0.5 text-xs',
        sm: 'px-1.5 py-0.5 text-2xs font-medium tracking-wide uppercase',
      },
    },
    defaultVariants: {
      variant: 'default',
      size: 'default',
    },
  }
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLSpanElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, size, ...props }: BadgeProps) {
  return (
    <span className={cn(badgeVariants({ variant, size, className }))} {...props} />
  );
}

export { Badge, badgeVariants };
